import gql from 'graphql-tag';

export default gql`
query queryTheirApps (
  $uuid: String!
) {
  queryTheirApps(uuid: $uuid) {
    items {
      uuid
      lang
      data
    }
  }
}
`;
